module.exports = __webpack_public_path__ + "images/sgp/10x10/bedroom.svg";